<template lang="pug">
.container.cardProcessos
  .content-processos
    .processos-main
      .busca-processos
        search-processos(
          @search="search",
          @input="simpleSearchAsync",
          @advancedInput="advancedSearchAsync",
          @advancedSearch="advancedSearch",
          @clear="clear"
        )
      .listagem-processos
        listagem-processos(
          titulo="Processos existentes"
          :loading="loading",
          :isBusca="isBusca",
          @carregaProcessos="carregaProcessos",
          @sort="sort",
          @goTo="goTo"
          :processos="processos"
        )
          app-paginacao(
            :total="totalProcessos",
            :pagina="filtro.pagina",
            @changePage="changePage"
          )
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import AppCabecalho from '@/components/AppCabecalho'
import AppPaginacao from '@/components/AppPaginacao'
import ListagemProcessos from './ListagemProcessos'
import SearchProcessos from './SearchProcessos'

const emptyFiltro = {
  parametro: '',
  pagina: 1,
  simplificado: true,
  ordem: 'dataCadastro',
  ordemDirecao: 'DESC'
}

export default {

  components: {
    AppPaginacao,
    AppCabecalho,
    SearchProcessos,
    ListagemProcessos
  },

  data () {
    return {
      totalProcessos: 0,
      isBusca: false,
      loading: false,
      filtro: _.cloneDeep(emptyFiltro),
      processos: []
    }
  },

  computed: {
    ...mapGetters({
      usuarioLogin: 'auth/usuarioLogado'
    })
  },

  async created () {
    this.carregaProcessos()
  },

  methods: {
    ...mapActions({
      getProcessosByFilter: 'processos/getProcessosByFilter',
      findByUsuarioAndTipo: 'cadastro/findByUsuarioAndTipo'
    }),

    simpleSearchAsync:  _.debounce(function (filtro) { this.search(filtro); }, 700), // eslint-disable-line
    advancedSearchAsync: _.debounce(function (filtro) { this.advancedSearch(filtro); }, 700), // eslint-disable-line

    changePage (newPage) {
      this.filtro.pagina = newPage
      this.findProcessos()
    },

    async findProcessos () {
      this.loading = true
      const result = await this.getProcessosByFilter(this.filtro)
      this.processos = result.processos
      this.totalProcessos = result.total
      this.loading = false
    },

    carregaProcessos () {
      this.clearFiltro()
      this.isBusca = false
      this.filtro.cpfCnpj = this.usuarioLogin.pessoa.cpfCnpj
      this.filtro.usuario = this.usuarioLogin.id

      this.findProcessos()
    },

    sort (data) {
      this.isBusca = true
      this.filtro.pagina = 1
      this.filtro.ordem = data.ordenacao
      this.filtro.ordemDirecao = data.tipo

      this.findProcessos()
    },

    clear () {
      this.isBusca = false
      this.clearFiltro()

      this.carregaProcessos()
    },

    clearFiltro () {
      this.filtro = _.cloneDeep(emptyFiltro)
    },

    search (param) {
      this.isBusca = true
      this.filtro.parametro = param
      this.filtro.simplificado = true
      this.filtro.pagina = 1

      this.findProcessos()
    },

    advancedSearch (filtroAtualizado) {
      this.isBusca = true
      this.filtro.numeroProcesso = filtroAtualizado.numeroProcesso
      this.filtro.cpfCnpj = filtroAtualizado.cpfCnpj
      this.filtro.nomeRazaoSocial = filtroAtualizado.nomeRazaoSocial
      this.filtro.tipo = filtroAtualizado.tipo || null
      this.filtro.status = filtroAtualizado.status || null
      this.filtro.simplificado = false
      this.filtro.pagina = 1

      this.findProcessos()
    },
    goTo (data, setLoader, resetLoader) {
      setLoader()
      this.$router.push({
        name: 'detalhes-processo',
        params: {
          idCadastro: data.numeroProtocolo,
          numeroProcesso: data.numeroProcesso,
          id: data.id
        }
      }, () => {
        resetLoader()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .content-processos {
    flex: 1;
    padding: 20px;
  }

  .processos-header {
    display: inline-flex;
    align-items: start;
    padding: 10px 0;
  }

  .processos-main {
    padding: 10px 0;
  }

  .busca-processos {
    padding: 10px 0;
  }

  .listagem-processos {
    padding: 10px 0;
  }

  @media (max-width: 780px) {

    .cardProcessos {
      position: relative;
      top: 20px;
      right: 60%;
    }
    .listagem-processos {
      position: relative;
      right: 48px;
      width: 385px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/processos/Processos.vue